'use client';

import { QueryKeys } from '@/constants/query-keys';
import { moviesApiService } from '@/services/(frontend)/movies/movie-api.service';
import { Movie } from '@cinemark/content-api-client';
import { useQuery } from '@tanstack/react-query';
import { useDynamicStaleTime } from '../shared/dynamic-stale-time';

export const useMovie = (movieId: string): ReturnType<typeof useQuery<Movie | null>> => {
  const updateQueryStaleTime = useDynamicStaleTime();

  return useQuery<Movie | null>({
    enabled: !!movieId,
    queryFn: async ({ signal }) => {
      if (!movieId) return null;

      try {
        const response = await moviesApiService.getMovie(movieId, signal);

        if (response.headers) {
          updateQueryStaleTime(QueryKeys.global.movie(movieId), response.headers);
        }

        return response.data;
      } catch {
        return null;
      }
    },
    queryKey: QueryKeys.global.movie(movieId),
  });
};
